export const enum TrifectaAutoplayRules {
  StopOnAnyWin = 'stop_on_any_win',
  StopOnBonusWin = 'stop_on_bonus_win',
}
